// src/components/Footer.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAvailableOrganizationSettings,
  getCurrentTenantDisplayInfo,
  getOrganizationSettings,
} from '../redux/auth/authSlice';
import moment from 'moment';
import {
  FaYoutube,
  FaInstagram,
  FaFacebookF,
  FaEnvelope,
  FaWhatsapp,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { getImagePath } from '../constants/defaultValues';

import appStore from '../assets/images/app_store.png';
import googelStore from '../assets/images/googel_store.png';
import { useThemeColors } from '../hooks/useThemeColors';
import AppConsts from '../lib/appconst';

const Footer = ({ darkMode }) => {
  const dispatch = useDispatch();
  const currentTenant = useSelector(getCurrentTenantDisplayInfo);
  const organizationSettings = useSelector(getAvailableOrganizationSettings);
  const { subTextColor } = useThemeColors(darkMode);

  useEffect(() => {
    dispatch(getOrganizationSettings());
  }, [dispatch]);

  // Phone number se spaces hatane ke liye helper (taaki crash na ho)
  const cleanPhoneNumber = organizationSettings?.phoneNumber
    ? organizationSettings.phoneNumber.replace(/\s+/g, '')
    : '';

  return (
    <footer className="bg-dark mt-5">
      <div className="footer-container py-4">
        <div className="container">
          <div className="row align-items-center justify-content-between mb-4">
            <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3 mb-md-0">
              {currentTenant?.logoId && (
                <img
                  src={`${getImagePath}${currentTenant.logoId}`}
                  alt={currentTenant?.name || 'Logo'}
                  width="80px"
                  height="80px"
                />
              )}
            </div>

            <div className="col-md-4 d-flex justify-content-md-end justify-content-center gap-2">
              <img src={appStore} alt="App Store" style={{ height: '35px' }} />
              <img
                src={googelStore}
                alt="Google Play"
                style={{ height: '35px' }}
              />
            </div>
          </div>

          <hr />
          <div className="row mt-4">
            <div className="col-md-6 mb-4">
              <h5 className="footer-heading mb-4 text-uppercase fw-bold text-white">
                Contact Us
              </h5>
              <ul className="footer-links list-unstyled">
                {/* Email Section */}
                <li className="mb-2">
                  <a
                    href={
                      organizationSettings?.email
                        ? `https://mail.google.com/mail/?view=cm&fs=1&to=${organizationSettings.email}`
                        : '#'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center contact-link text-decoration-none"
                    style={{ color: subTextColor }}
                  >
                    <FaEnvelope className="icon me-2" />
                    <span>{organizationSettings?.email || 'Loading...'}</span>
                  </a>
                </li>

                {/* WhatsApp Section - Fixed Replace Error */}
                <li className="mb-2">
                  <a
                    href={`https://wa.me/${cleanPhoneNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center contact-link text-decoration-none"
                    style={{ color: subTextColor }}
                  >
                    <FaWhatsapp className="icon me-2 whatsapp text-success" />
                    <span>
                      {organizationSettings?.phoneNumber || 'Loading...'}
                    </span>
                  </a>
                </li>

                {/* Address Section */}
                <li className="mb-2">
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      organizationSettings?.physicalAddress || ''
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center contact-link text-decoration-none"
                    style={{ color: subTextColor }}
                  >
                    <FaMapMarkerAlt className="icon me-2 location text-danger" />
                    <span>
                      {organizationSettings?.physicalAddress || 'Loading...'}
                    </span>
                  </a>
                </li>
              </ul>

              <div className="col-md-4 d-flex justify-content-center gap-4 social-wrapper">
                <a href="#" className="social-icon youtube">
                  <FaYoutube />
                  <span className="tooltip">YouTube</span>
                </a>
                <a href="#" className="social-icon instagram">
                  <FaInstagram />
                  <span className="tooltip">Instagram</span>
                </a>
                <a href="#" className="social-icon facebook">
                  <FaFacebookF />
                  <span className="tooltip">Facebook</span>
                </a>
              </div>
            </div>
          </div>

          <hr />
          <div className="powered-by-wrapper">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div className="copyright-text mb-3 mb-md-0">
                <p className="m-0 text-muted">
                  © {moment().year()}{' '}
                  <span className="fw-bold text-white">
                    {currentTenant?.name || 'Company'}
                  </span>
                  . All rights reserved.
                </p>
              </div>

              <div className="brand-signature">
                <p className="m-0 text-muted">
                  Powered By{' '}
                  <a
                    href="https://www.mcodetechnologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mcode-link"
                  >
                    mCode Technologies
                  </a>{' '}
                  V:{AppConsts.version}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
